// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "styles" + "." + "f305a098bc0de5da1738" + ".css";
};